(function () {
  'use strict';

  const CART_UPDATE_EVENT = 'cart:update';
  const CART_JSON_URL = '/cart.js';

  function formatMoney(cents, format) {
    if (!format) return String(cents / 100);

    const amount = (Math.abs(cents) / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(Math.abs(cents) / 100));
    const amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getProgressPercent(cartTotal, thresholds) {
    const count = thresholds.length;
    if (count === 0) return 0;
    if (count === 1) return Math.min(cartTotal / thresholds[0], 1) * 100;

    const positions = thresholds.map(function (_, index) {
      return (index / (count - 1)) * 100;
    });

    if (cartTotal >= thresholds[count - 1]) return 100;

    if (cartTotal <= 0) return 0;

    if (cartTotal < thresholds[0]) {
      return (cartTotal / thresholds[0]) * positions[0];
    }

    for (let i = 0; i < count - 1; i += 1) {
      if (cartTotal < thresholds[i + 1]) {
        const ratio = (cartTotal - thresholds[i]) / (thresholds[i + 1] - thresholds[i]);
        return positions[i] + ratio * (positions[i + 1] - positions[i]);
      }
    }

    return 100;
  }

  function readThresholds(root) {
    const milestones = root.querySelectorAll('[data-threshold]');
    const thresholds = [];

    milestones.forEach(function (node) {
      const value = parseInt(node.getAttribute('data-threshold') || '0', 10);
      if (!Number.isNaN(value)) thresholds.push(value);
    });

    return thresholds;
  }

  function setTrackFill(root, progress, animate) {
    const fill = root.querySelector('[data-crp-fill]');
    if (!fill) return;

    root.style.setProperty('--crp-progress', progress + '%');
    fill.classList.toggle('crp__track-fill-wrap--active', progress > 0);

    if (!animate || fill.dataset.crpInitialized === 'true') {
      fill.style.width = progress + '%';
      fill.dataset.crpInitialized = 'true';
      return;
    }

    fill.style.width = '0%';
    fill.dataset.crpInitialized = 'true';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = progress + '%';
      });
    });
  }

  function updateProgress(root, cartTotal, animate) {
    const thresholds = readThresholds(root);
    const progress = getProgressPercent(cartTotal, thresholds);
    let nextThreshold = null;

    root.querySelectorAll('[data-threshold]').forEach(function (node) {
      const threshold = parseInt(node.getAttribute('data-threshold') || '0', 10);
      const isComplete = cartTotal >= threshold;

      node.classList.toggle('crp__milestone--complete', isComplete);
      node.classList.toggle('crp__milestone--pending', !isComplete);

      if (!isComplete && nextThreshold === null) {
        nextThreshold = threshold;
      }
    });

    setTrackFill(root, progress, animate);

    const message = root.querySelector('[data-crp-message]');
    if (!message) return;

    const template = root.getAttribute('data-message-template') || '';
    const moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    const hideWhenComplete = root.getAttribute('data-hide-message-complete') === 'true';

    if (!template) {
      message.hidden = true;
      return;
    }

    if (nextThreshold === null) {
      message.hidden = hideWhenComplete;
      if (!hideWhenComplete) {
        message.textContent = root.getAttribute('data-message-complete') || '';
      }
      return;
    }

    const remaining = Math.max(nextThreshold - cartTotal, 0);
    message.hidden = false;
    message.textContent = template.replace(
      /\[amount\]|\{\{\s*amount\s*\}\}/g,
      formatMoney(remaining, moneyFormat)
    );
  }

  function bindRoot(root) {
    if (root.dataset.crpBound === 'true') return;
    root.dataset.crpBound = 'true';

    const initialTotal = parseInt(root.getAttribute('data-cart-total') || '0', 10);
    updateProgress(root, Number.isNaN(initialTotal) ? 0 : initialTotal, true);
  }

  function fetchCartTotal() {
    return fetch(CART_JSON_URL, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        return typeof cart.total_price === 'number' ? cart.total_price : 0;
      })
      .catch(function () {
        return null;
      });
  }

  function refreshAll(cartTotal, animate) {
    document.querySelectorAll('[data-crp-root]').forEach(function (root) {
      if (!(root instanceof HTMLElement)) return;

      if (cartTotal === null) {
        fetchCartTotal().then(function (total) {
          if (total !== null) updateProgress(root, total, animate);
        });
        return;
      }

      updateProgress(root, cartTotal, animate);
    });
  }

  function init() {
    document.querySelectorAll('[data-crp-root]').forEach(function (root) {
      if (root instanceof HTMLElement) bindRoot(root);
    });
  }

  document.addEventListener(CART_UPDATE_EVENT, function (event) {
    const detail = event && event.detail;
    const resource = detail && detail.resource;
    const total =
      resource && typeof resource.total_price === 'number' ? resource.total_price : null;

    refreshAll(total, true);
  });

  document.addEventListener('shopify:section:load', function () {
    init();
    refreshAll(null, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
